// @flow
import {OrderedMap} from 'immutable';

export function orderedMapToArray<T>(mapList: OrderedMap<string, T>): T[] {
  return mapList.toList().toArray();
}

export function arrayToOrderedMap<T: {[key: string]: any}>(
  array: T[] = [],
  criteria: string = 'id'
): OrderedMap<string, T> {
  const a = array.map((value, index) =>
    value && value[criteria] ? [value[criteria], value] : [`${index}`, value]
  );

  return OrderedMap(a);
}

export function sliceWithCondition<T>(
  array: T[],
  condition: (value: T) => boolean
): T[] {
  const index = array.findIndex(condition);

  if (index === -1) {
    return array;
  } else {
    return array.slice(0, index);
  }
}

export function insertAt<T>(
  array: T[],
  item: T | T[],
  index: number = -1
): T[] {
  const itemsToInsert = Array.isArray(item) ? item : [item];
  if (index < 0 || index >= array.length) {
    return [...array, ...itemsToInsert];
  }

  return [...array.slice(0, index), ...itemsToInsert, ...array.slice(index)];
}

export function arrayMove<T>(array: T[], from: number, to: number): T[] {
  const newArray = [...array];
  const item = newArray.splice(from, 1)[0];
  newArray.splice(to, 0, item);

  return newArray;
}

export function moveBetweenArrays<T>(
  source: T[],
  destination: T[],
  sourceIndex: number,
  destinationIndex: number
): {source: T[], destination: T[]} {
  const sourceClone = Array.from(source);
  const destClone = Array.from(destination);
  const [removed] = sourceClone.splice(sourceIndex, 1);

  destClone.splice(destinationIndex, 0, removed);
  return {
    destination: destClone,
    source: sourceClone,
  };
}
